import { pdfjs } from 'react-pdf';

// Use absolute path from origin to avoid being affected by React Router paths
// This ensures /pdf.worker.mjs is always loaded from root, not relative to current route
const workerPath = `${window.location.origin}/pdf.worker.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = workerPath;

